/* TheWholesalerCo theme.js */
(function(){
  'use strict';
  var money = window.TWC_moneyFormat || '${{amount}}';
  function fmt(cents, precision, thousands, decimal){
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var num = (cents/100).toFixed(precision);
    var parts = num.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (thousands||','));
    var centsPart = parts[1] ? (decimal||'.') + parts[1] : '';
    return dollars + centsPart;
  }
  function formatMoney(cents){
    try{
      return money.replace(/\{\{\s*(\w+)\s*\}\}/g, function(m, token){
        switch(token){
          case 'amount': return fmt(cents, 2, ',', '.');
          case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
          case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
          case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
          case 'amount_no_decimals_with_space_separator': return fmt(cents, 0, ' ', ',');
          case 'amount_with_period_and_space_separator': return fmt(cents, 2, ' ', '.');
          default: return fmt(cents, 2, ',', '.');
        }
      });
    }catch(e){return (cents/100).toFixed(2);}
  }

  /* ---------- mega menu (desktop, hover-intent) ---------- */
  var megaTimer=null;
  function closeAll(){document.querySelectorAll('.has-mega.open').forEach(function(i){i.classList.remove('open');var p=i.querySelector('.mega');if(p)p.classList.remove('show');});}
  document.querySelectorAll('.has-mega').forEach(function(item){
    var btn=item.querySelector('button'), panel=item.querySelector('.mega');
    if(!btn||!panel) return;
    function open(){clearTimeout(megaTimer);closeAll();item.classList.add('open');panel.classList.add('show');}
    function scheduleClose(){clearTimeout(megaTimer);megaTimer=setTimeout(function(){item.classList.remove('open');panel.classList.remove('show');},220);}
    // hover the whole item (button + panel are inside it) keeps it open
    item.addEventListener('mouseenter',open);
    item.addEventListener('mouseleave',scheduleClose);
    panel.addEventListener('mouseenter',function(){clearTimeout(megaTimer);});
    btn.addEventListener('click',function(e){e.preventDefault();item.classList.contains('open')?scheduleClose():open();});
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeAll();closeDrawers();}});
  document.addEventListener('click',function(e){if(!e.target.closest('.has-mega'))closeAll();});

  /* ---------- drawers (mobile nav + cart) ---------- */
  var scrim=document.getElementById('scrim');
  function openDrawer(id){var d=document.getElementById(id);if(!d)return;d.classList.add('open');scrim&&scrim.classList.add('open');}
  function closeDrawers(){document.querySelectorAll('.drawer.open').forEach(function(d){d.classList.remove('open');});scrim&&scrim.classList.remove('open');}
  scrim&&scrim.addEventListener('click',closeDrawers);
  document.querySelectorAll('[data-open-drawer]').forEach(function(b){b.addEventListener('click',function(){openDrawer(b.getAttribute('data-open-drawer'));});});
  document.querySelectorAll('[data-close-drawer]').forEach(function(b){b.addEventListener('click',closeDrawers);});

  /* ---------- cart ---------- */
  function renderCart(cart){
    var wrap=document.getElementById('cart-items'); if(!wrap) return;
    var countEls=document.querySelectorAll('.cart-count');
    countEls.forEach(function(el){el.textContent=cart.item_count; el.style.display=cart.item_count?'inline-block':'none';});
    if(!cart.items.length){
      wrap.innerHTML='<div class="cart-empty">Your cart is empty.<br><br><a class="btn btn-o" href="/collections">Browse the catalogue</a></div>';
      var f=document.getElementById('cart-foot'); if(f) f.style.display='none';
      return;
    }
    var f=document.getElementById('cart-foot'); if(f) f.style.display='block';
    var sub=document.getElementById('cart-subtotal'); if(sub) sub.textContent=formatMoney(cart.total_price);
    wrap.innerHTML=cart.items.map(function(it){
      var img=it.image?('<img src="'+it.image.replace(/(\.[a-z]+)(\?|$)/i,'_120x120$1$2')+'" alt="">'):'<div style="width:64px"></div>';
      var opts=(it.options_with_values||[]).map(function(o){return o.value;}).join(' · ');
      return '<div class="cart-line" data-key="'+it.key+'">'+img+
        '<div><div class="nm">'+it.product_title+'</div>'+
        (opts?'<div class="op">'+opts+'</div>':'')+
        '<div class="qtyrow"><button data-ch="-1">−</button><span>'+it.quantity+'</span><button data-ch="1">+</button></div>'+
        '<button class="rm">Remove</button></div>'+
        '<div class="pr">'+formatMoney(it.final_line_price)+'</div></div>';
    }).join('');
    wrap.querySelectorAll('.cart-line').forEach(function(line){
      var key=line.getAttribute('data-key');
      line.querySelectorAll('[data-ch]').forEach(function(btn){
        btn.addEventListener('click',function(){
          var q=parseInt(line.querySelector('.qtyrow span').textContent,10)+parseInt(btn.getAttribute('data-ch'),10);
          changeItem(key,Math.max(0,q));
        });
      });
      line.querySelector('.rm').addEventListener('click',function(){changeItem(key,0);});
    });
  }
  function fetchCart(){fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(renderCart);}
  function changeItem(key,qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();}).then(renderCart);
  }
  window.TWCaddToCart=function(id,qty){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:qty||1}]})})
      .then(function(r){return r.json();}).then(function(){fetchCart();openDrawer('cart-drawer');});
  };
  if(document.getElementById('cart-items')) fetchCart();

  /* ---------- product ---------- */
  var pform=document.getElementById('product-form');
  if(pform){
    var data=window.TWCproduct||{variants:[]};
    var loggedIn=window.TWCloggedIn===true;
    var current=null;
    var priceEl=document.getElementById('pdp-price'), unitEl=document.getElementById('pdp-unit');
    var openBox=document.getElementById('price-open'), gateBox=document.getElementById('price-gated');
    var buyBox=document.getElementById('buy-open'), idInput=document.getElementById('variant-id');
    var addBtn=document.getElementById('add-btn'), leadEl=document.getElementById('pdp-lead');
    var qtyInput=document.getElementById('pdp-qty');

    function isBulk(v){
      // bulk = anything at/above 1 kg; small (sample/g) stays open
      var t=(v.title+' '+(v.options||[]).join(' ')).toLowerCase();
      return /kg/i.test(t);
    }
    function select(v){
      current=v; if(!v) return;
      idInput.value=v.id;
      if(leadEl && v.metafields_lead) leadEl.textContent=v.metafields_lead;
      var gate = isBulk(v) && !loggedIn;
      if(gate){
        openBox.style.display='none'; buyBox.style.display='none'; gateBox.style.display='block';
      }else{
        openBox.style.display='block'; buyBox.style.display='flex'; gateBox.style.display='none';
        priceEl.textContent=formatMoney(v.price);
        if(unitEl) unitEl.textContent=v.title;
        if(addBtn){addBtn.disabled=!v.available;addBtn.textContent=v.available?'Add to cart':'Sold out';}
      }
    }
    // option pills
    document.querySelectorAll('[data-opt-group]').forEach(function(group){
      group.querySelectorAll('.pill').forEach(function(pill){
        pill.addEventListener('click',function(){
          group.querySelectorAll('.pill').forEach(function(p){p.classList.remove('sel');});
          pill.classList.add('sel');
          resolveVariant();
        });
      });
    });
    var carrierSel=document.getElementById('carrier-select');
    carrierSel&&carrierSel.addEventListener('change',resolveVariant);
    function resolveVariant(){
      var chosen={};
      document.querySelectorAll('[data-opt-group]').forEach(function(group){
        var name=group.getAttribute('data-opt-name');
        var sel=group.querySelector('.pill.sel');
        if(sel) chosen[name]=sel.getAttribute('data-value');
      });
      if(carrierSel && carrierSel.closest('[style*="display: block"], .opt:not([hidden])')){
        chosen[carrierSel.getAttribute('data-opt-name')]=carrierSel.value;
      }
      var match=data.variants.filter(function(v){
        return (v.options||[]).every(function(val,i){
          var nm=data.option_names[i];
          return chosen[nm]===undefined || chosen[nm]===val;
        });
      });
      // prefer fully-available match
      select(match.find(function(v){return v.available;})||match[0]||data.variants[0]);
    }
    // qty
    var plus=document.getElementById('qty-plus'),minus=document.getElementById('qty-minus');
    plus&&plus.addEventListener('click',function(){qtyInput.value=(parseInt(qtyInput.value,10)||1)+1;});
    minus&&minus.addEventListener('click',function(){qtyInput.value=Math.max(1,(parseInt(qtyInput.value,10)||1)-1);});
    // add
    pform.addEventListener('submit',function(e){
      e.preventDefault();
      if(!current||!current.available) return;
      addBtn.disabled=true;addBtn.textContent='Adding…';
      window.TWCaddToCart(current.id,parseInt(qtyInput.value,10)||1).then(function(){
        addBtn.disabled=false;addBtn.textContent='Add to cart';
      });
    });
    // tabs
    var tabs=document.getElementById('pdp-tabs');
    tabs&&tabs.addEventListener('click',function(e){var b=e.target.closest('button');if(!b)return;
      tabs.querySelectorAll('button').forEach(function(x){x.classList.remove('sel');});b.classList.add('sel');
      document.querySelectorAll('.panel').forEach(function(p){p.classList.toggle('sel',p.getAttribute('data-panel')===b.getAttribute('data-t'));});
    });
    // gallery thumbs
    var mainImg=document.getElementById('pdp-main-img');
    document.querySelectorAll('.thumbs img').forEach(function(t){
      t.addEventListener('click',function(){if(mainImg){mainImg.src=t.getAttribute('data-full')||t.src;}document.querySelectorAll('.thumbs img').forEach(function(x){x.classList.remove('active');});t.classList.add('active');});
    });
    resolveVariant();
  }

  /* ---------- collection: mobile filter toggle + card quick-add ---------- */
  var ft=document.querySelector('.filter-toggle');
  ft&&ft.addEventListener('click',function(){var r=document.querySelector('.rail');if(r)r.classList.toggle('mobile-hidden');});
  function bindQuickAdd(b){
    b.addEventListener('click',function(e){e.preventDefault();var id=b.getAttribute('data-quick-add');if(!id)return;b.textContent='Adding…';window.TWCaddToCart(id,1).then(function(){b.textContent='Added ✓';setTimeout(function(){b.textContent='Add to cart';},1500);});});
  }
  document.querySelectorAll('[data-quick-add]').forEach(bindQuickAdd);

  /* ---------- product recommendations (Formulators also source) ---------- */
  var rw=document.getElementById('rec-wrap');
  if(rw && rw.getAttribute('data-url')){
    fetch(rw.getAttribute('data-url')).then(function(r){return r.text();}).then(function(html){
      var tmp=document.createElement('div');tmp.innerHTML=html;
      var grid=tmp.querySelector('.pgrid');
      if(grid && grid.children.length){
        document.getElementById('rec-mount').appendChild(grid);
        grid.querySelectorAll('[data-quick-add]').forEach(bindQuickAdd);
        rw.style.display='block';
      }
    }).catch(function(){});
  }
})();
